import React from 'react'

import { InterceptorsProvider } from 'commons/customHooks/useInterceptors'
import { LocalStorageChangesListener } from 'components'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from 'store/store'

import App from './App'
import reportWebVitals from './reportWebVitals'
import 'commons/utils/date'
import 'react-toastify/dist/ReactToastify.css'
import './i18n'

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <InterceptorsProvider>
        <LocalStorageChangesListener />
        <App />
      </InterceptorsProvider>
    </Provider>
  </React.StrictMode>,
)

reportWebVitals()
